import {
  pushToFirebase, getFromFirebase, removeItemFromFirebase,
} from '../../../mixins/firebase';

export default {

  // rewards CRUD
  async getAllRewards(context) {
    const updateRewards = (response) => {
      context.commit('SET_REWARDS', response);
    };

    await getFromFirebase('userRewards', updateRewards);
  },
  async addReward({ dispatch }, reward) {
    await pushToFirebase('userRewards', reward);
    dispatch('getAllRewards');
  },
  removeReward({ dispatch }, rewardFirekey) {
    removeItemFromFirebase('userRewards', rewardFirekey);
    dispatch('getAllRewards');
  },
  // logs CRUD END //
};
